import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/question';
import * as questionPageAction from '../actions/question';
import { Log } from 'ng2-logger';
import { QuestionService } from '../../api/question-service';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';

import Translator from '../../core/i18n';
import { IAddQuestions, IDeletedQuestion, IGetQuestion, IGetQuestionById, IGetQuestionDifficulties, IGetRefreshUploadMultiQuestion, IQuestionList } from '../../models/action/question';
const T = Translator.create();
const _logger = Log.create('question Saga');
const _questionService = new QuestionService();

export interface IResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}
function* getQuestionLists(params: IQuestionList) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _questionService.RequestGetQuestionListsAsync({ ...params.filters, ...params.paging })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            yield put(questionPageAction.SetQuestionList(pageData.results, pageData.filters, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}
function* addQuestions(params: IAddQuestions) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _questionService.RequestAddQuestionAsync(params.values)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            Notification.setNotification('success', params.values && params.values.questionId ? T.t('r_question_updated') : T.t('r_question_added'), 'topRight');
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.callback) {
            params.callback({ questionId: (params.values && params.values.questionId) ? params.values.questionId : pageData, learningOutcomeId: params?.values?.learningOutcomeId });
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.callback) {
            params.callback(false);
        }
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}
function* deleteQuestion(params: IDeletedQuestion) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _questionService.RequestDeleteAddQuestionAsync({ ...params.filters, ...params })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            Notification.setNotification('success', T.t('r_gen_questionBank_deleted_succes'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* getQuestion(params: IGetQuestion) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _questionService.RequestGetQuestionsAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            yield put(questionPageAction.SetQuestion(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
            if (params.callback) {
                yield params.callback();
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* getQuestionById(params: IGetQuestionById) {
    let isError: boolean = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _questionService.RequestGetQuestionByIdAsync(params.questionId).then((response: Response) => {
            return response;
        }).then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }
            return response.json();
        }).then((responseData: any) => {
            if (isError) {
                errorList = responseData;
            } else {
                pageData = responseData;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_question_get_error'), 'topRight');
            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
        }

        if (!isError) {
            yield put(questionPageAction.editQuestionSetAction(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
            if (params.callback) {
                params.callback(params.questionId);
            }
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_question_get_error') + ' / ' + error, '', '', 'topRight', 'error'));
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    }
}

function* getQuestionDifficulties(params: IGetQuestionDifficulties) {
    let isError: boolean = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _questionService.RequestGetQuestionDifficultiesAsync({ ...params }).then((response: Response) => {
            return response;
        }).then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }
            return response.json();
        }).then((responseData: any) => {
            if (isError) {
                errorList = responseData;
            } else {
                pageData = responseData;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_difficulty_get_error'), 'topRight');
            if (params.spinnerId) {
                yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            }
        }

        if (!isError) {
            yield put(questionPageAction.setQuestionDifficulties(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        }
    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_difficulty_get_error') + ' / ' + error, '', '', 'topRight', 'error'));
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    }
}

function* getRedirectToAlmsQuestionBank(params: any): any {
    let isError = false;
    let errorList: any;
    const _questionService = new QuestionService();
    const requestReturn = yield _questionService.RedirectToAlmsQuestionBank(params.parameters ? params.parameters : null)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        })
        .then(response => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

    if (isError) {
        yield put(coreActions.newNotification(T.t('r_api_gen_connecttoalms'), '', '', 'topRight', 'error', 0, params.spinnerId, 'set'));
    } else {
        window.open(requestReturn, '_blank');
    }
}

function* questionBankDownloadTemplateExcel(params: any): any {
    let isError = false;
    let errorList: any;

    const error = yield _questionService.RequestDownloadTemplateExcelAsync(params.timestamp, params.questionType);

    if (error) {
        isError = true;
        errorList = error;
    }

    if (isError) {
        errorList ?
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            }) : Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
    }
}

function* GetRefreshUploadMultiQuestion(params: IGetRefreshUploadMultiQuestion) {
    let isError: boolean = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _questionService.RequestGetRefreshUploadMultiQuestionAsync(params.parameters).then((response: Response) => {
            return response;
        }).then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }
            return response.json();
        }).then((responseData: any) => {
            if (isError) {
                errorList = responseData;
            } else {
                pageData = responseData;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
        } else {
            yield put(questionPageAction.SetRefreshUploadMultiQuestion(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        }

    } catch (error: any) {
        yield put(coreActions.newNotification(T.t('r_default_error_message') + ' / ' + error, '', '', 'topRight', 'error'));
    }
}

function* watchQuestionLists() {
    yield takeEvery(constants.actions.GET_QUESTION_LIST, getQuestionLists);
    return null;
}
function* watchAddQuestions() {
    yield takeEvery(constants.actions.ADD_QUESTION, addQuestions);
    return null;
}
function* watchDeleteQuestions() {
    yield takeEvery(constants.actions.DELETE_QUESTION, deleteQuestion);
    return null;
}
function* watchGetQuestions() {
    yield takeEvery(constants.actions.GET_QUESTION, getQuestion);
    return null;
}
function* watchSetQuestions() {
    yield takeEvery(constants.actions.GET_QUESTION_DATA, getQuestionById);
    return null;
}
function* watchGetQuestionDifficulties() {
    yield takeEvery(constants.actions.GET_QUESTION_DIFFICULTIES, getQuestionDifficulties);
    return null;
}

export function* watchRedirectToAlmsQuestionBank() {
    yield takeEvery(constants.actions.REDIRECT_TO_ALMS_QUESTION_BANK, getRedirectToAlmsQuestionBank);
}

export function* watchQuestionBankDownloadTemplateExcel() {
    yield takeEvery(constants.actions.QUESTION_BANK_DOWNLOAD_TEMPLATE_EXCEL, questionBankDownloadTemplateExcel);
}

export function* watchGetRefreshUploadMultiQuestion() {
    yield takeEvery(constants.actions.GET_REFRESH_UPLOAD_MULTI_QUESTION, GetRefreshUploadMultiQuestion);
}

export function* QuestionSagas() {
    yield all([
        watchQuestionLists(),
        watchAddQuestions(),
        watchDeleteQuestions(),
        watchGetQuestions(),
        watchSetQuestions(),
        watchGetQuestionDifficulties(),
        watchRedirectToAlmsQuestionBank(),
        watchQuestionBankDownloadTemplateExcel(),
        watchGetRefreshUploadMultiQuestion()
    ]);
}